export enum StatusType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
